import React, {Component} from 'react';
import {connect} from "react-redux";
import Logout from "@material-ui/icons/PowerSettingsNew";
import Button from "components/CustomButtons/Button.jsx";
import Hidden from '@material-ui/core/Hidden';
import "./../landing.css";


class Authorization extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render () {
        const { user } = this.props;
        return (
            <div style={{color: "#fff"}}>
                {
                    (user) ?
                        <div className={'signin-container'}>
                            <a href="/login" title={'Logout'}>
                                <Button
                                    type="button"
                                    color="secondary"
                                    size={"sm"}
                                >
                                    <Logout/>
                                    <Hidden mdDown>
                                        Sign Out
                                    </Hidden>
                                </Button>
                            </a>
                        </div>
                        :
                        <div className={'signin-container'}>
                            <a href="/login" title={'Logout'}>
                                <Button
                                    type="button"
                                    color="secondary"
                                    size={"sm"}
                                >
                                    <Logout/>
                                    <Hidden mdDown>
                                        Sign In
                                    </Hidden>
                                </Button>
                            </a>
                        </div>
                }
            </div>
    )
    }
}

function mapStateToProps(state) {
    const { user } = state;
    return {
        user,
    };
};

export default connect(mapStateToProps)(Authorization);



// WEBPACK FOOTER //
// ./src/layouts/Landing/component/Authorization.js